import { compose } from 'recompose';
import { connect } from 'react-redux';

import { selectors as settingsSelectors } from 'state/settings';

import GDPROptions from 'components/summary/GDPROptions/component';

const enhance = compose(
  connect((state) => ({
    conditionsUrl: settingsSelectors.getLegalLinks(state).terms_and_conditions,
    privacyUrl: settingsSelectors.getLegalLinks(state).privacy,
  }))
);

export default enhance(GDPROptions);
